export const isValidIin = (iin, isEditing) => {
  const onlyNumbersRegex = /^[0-9]*$/;
  return iin.length === 12 && onlyNumbersRegex.test(iin) && !isEditing;
};
